import { OrganizationKeyName } from "../../../model/Organization";
import { ProductListItem } from "../../products/models/product";
import { GetProductListActionFilters } from "../model/GetProductListActionFilters";

export const GET_PRODUCT_LIST_SUCCESS = "SHOP:GET_PRODUCT_LIST_SUCCESS";

export const getProductListSuccessAction = (
  organization: OrganizationKeyName,
  filters: GetProductListActionFilters,
  data: ProductListItem[]
) => ({
  type: GET_PRODUCT_LIST_SUCCESS as typeof GET_PRODUCT_LIST_SUCCESS,
  organization,
  filters,
  data,
});

export type GetProductListSuccessAction = ReturnType<
  typeof getProductListSuccessAction
>;
